module.exports = __webpack_public_path__ + "img/WechatIMG3783.780bbb3b.png";